import React from "react";
import { APP } from "@/constants/testIds";

/**
 * Reusable email/password form. Renders name field only when `showName` is true.
 * Delegates submission to `onSubmit(e)`.
 */
export default function AuthFormFields({
  showName,
  name, setName,
  email, setEmail,
  password, setPassword,
  onSubmit,
  submitting,
  submitLabel,
  errorMsg,
}) {
  return (
    <form onSubmit={onSubmit} data-testid={APP.authForm} className="mt-8 space-y-4">
      {showName && (
        <label className="block">
          <span className="text-xs uppercase tracking-widest text-[color:var(--muted)]">Name (optional)</span>
          <input
            data-testid={APP.authNameInput}
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Jane Founder"
            className="mt-1 w-full px-4 py-3 bg-transparent border border-[color:var(--fg)] focus:outline-none focus:border-[color:var(--accent)]"
          />
        </label>
      )}
      <label className="block">
        <span className="text-xs uppercase tracking-widest text-[color:var(--muted)]">Email</span>
        <input
          data-testid={APP.authEmailInput}
          type="email"
          required
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@founder.com"
          className="mt-1 w-full px-4 py-3 bg-transparent border border-[color:var(--fg)] focus:outline-none focus:border-[color:var(--accent)]"
        />
      </label>
      <label className="block">
        <span className="text-xs uppercase tracking-widest text-[color:var(--muted)]">Password</span>
        <input
          data-testid={APP.authPasswordInput}
          type="password"
          required
          minLength={6}
          autoComplete={showName ? "new-password" : "current-password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="min 6 characters"
          className="mt-1 w-full px-4 py-3 bg-transparent border border-[color:var(--fg)] focus:outline-none focus:border-[color:var(--accent)]"
        />
      </label>

      {errorMsg && (
        <div data-testid={APP.authError} className="text-sm text-[color:var(--hot)] border border-[color:var(--hot)] px-4 py-2">
          {errorMsg}
        </div>
      )}

      <button
        type="submit"
        data-testid={APP.authSubmitBtn}
        disabled={submitting}
        className="w-full py-4 bg-[color:var(--fg)] text-[color:var(--bg)] font-semibold uppercase tracking-wider text-sm disabled:opacity-60 hover:opacity-90"
      >
        {submitting ? "..." : submitLabel}
      </button>
    </form>
  );
}
